import React,{useState} from "react";
const CardOverSixYears = ({
    clsName,
    onSelectAnswer,
    backClick,
    setOldCard
}) => {
    const [checkedQuestionOne, setCheckedQuestionOne] = useState("unchecked");
    const [checkedQuestionTwo, setCheckedQuestionTwo] = useState("unchecked");
    
    const optionSelected = async(e) => {
        if (e.target.value === "236") {
            setCheckedQuestionOne("checked");
            setCheckedQuestionTwo("unchecked");
            setOldCard("236");
            onSelectAnswer(e);
          }
          if (e.target.value === "237") {
            setCheckedQuestionOne("unchecked");
            setCheckedQuestionTwo("checked");
            setOldCard("237");
            onSelectAnswer(e);
          }
    }
    return (
        <>
        <div className={`question-content mt-0 scale-down-ver-center  px-3 py-lg-3 py-md-3 py-sm-2 py-2 pb-3 ${clsName}`}>
                      <div className="row">
                        <div className="col-6">
                          <div className=" mb-2"> 
                            <button
                                type="button"
                                className={`btn-comm2 py-lg-3 py-md-3 py-sm-2 py-2 w-100 nextBtn ${checkedQuestionOne}`}
                                onClick={optionSelected}
                                value="236"
                                name="card_over_six_years"
                                id="card_over_six_years"
                                data-quest-id={81}
                                data-ans-id={236}
                                data-ans-label={null}
                            >Yes
                            </button>
                            </div>
                        </div>
                        <div className="col-6">
                          <div className=" mb-2"> 
                            <button
                                type="button"
                                className={`btn-comm2 py-lg-3 py-md-3 py-sm-2 py-2 w-100 nextBtn ${checkedQuestionTwo}`}
                                onClick={optionSelected}
                                value="237"
                                name="card_over_six_years"
                                id="card_over_six_years"
                                data-quest-id={81}
                                data-ans-id={237}
                                data-ans-label={null}
                            >No
                            </button>
                            </div>
                        </div>
                      </div>
                      <p className="text-center bck-marwid">
                    <button
                      name="btn_qest_76"
                      className="btn btn-secondary backbtn1a"
                      id=""
                      value=""
                      type="button"
                      onClick={backClick}
              
                    >Go Back</button>
                    </p>
                    </div>
        </>
    )
}
export default CardOverSixYears;